import { createSlice } from "@reduxjs/toolkit";

export const capitalOverviewSlice = createSlice({
  name: "capitalOverview",
  initialState: {
    init: false,
    widget: null,
    formattedBalance: null,
    difference: null,
    numberOfSources: null,
    savingsSourcesData: {
      cash: null,
      bank_account: null,
      stocks: null,
      crypto: null,
    },
  },
  reducers: {
    setData: (state, action) => {
      const {
        savingsSourcesData,
        formattedBalance,
        difference,
        numberOfSources,
        widget,
      } = action.payload;
      state.savingsSourcesData = {
        cash: savingsSourcesData.cash,
        bank_account: savingsSourcesData.bank_account,
        stocks: savingsSourcesData.stocks,
        crypto: savingsSourcesData.crypto,
      };
      state.widget = widget;
      state.formattedBalance = formattedBalance;
      state.difference = difference;
      state.numberOfSources = numberOfSources;
      state.init = true;
    },
    setWidget: (state, action) => {
      state.widget = action.payload;
    },
  },
});

export const { setData, setWidget } = capitalOverviewSlice.actions;

export default capitalOverviewSlice.reducer;
